import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Marathon',
    description:
        'Marathon is the running companion that turns every mile into momentum, with live tracking, heart rate zones, and adaptive coaching built for runners who want more.',
    url: getOrigin()
}
